import React from 'react';
export function HeroSection() {
  return <section className="relative pt-10 pb-12 md:pt-24 md:pb-28 overflow-hidden px-4 sm:px-6 lg:px-8" data-id="element-124">
      {/* Background glow — hidden on mobile for GPU perf */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-[600px] bg-cosmic-600/15 blur-[150px] rounded-full pointer-events-none hidden md:block" data-id="element-125" />

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-126">
        {/* Brand Tag */}
        <div className="hero-animate-1 inline-flex items-center gap-2 px-3 py-1 md:px-4 md:py-1.5 rounded-full bg-cosmic-500/10 border border-cosmic-500/20 text-cosmic-400 font-semibold text-xs md:text-sm tracking-wider mb-4 md:mb-8" data-id="element-127">
          ✨ MI ESPACIO INTERIOR
        </div>

        {/* Main Headline */}
        <h1 className="hero-animate-2 text-3xl sm:text-5xl md:text-7xl lg:text-8xl font-extrabold leading-[1.08] tracking-tight mb-2 md:mb-4 text-white" data-id="element-128">
          Todo lo que tu hijo necesita para su mundo emocional.
        </h1>

        {/* Accent Subheadline */}
        <p className="hero-animate-2 text-2xl sm:text-4xl md:text-6xl lg:text-7xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-400 to-cosmic-400 mb-6 md:mb-12" data-id="element-129">
          Listo. Desde hoy.
        </p>

        {/* Product Image */}
        <div className="relative max-w-sm md:max-w-3xl mx-auto mb-6 md:mb-12" data-id="element-130">
          <div className="absolute inset-0 bg-gradient-to-tr from-cosmic-600/20 to-blue-400/10 blur-3xl rounded-full scale-110 hidden md:block" data-id="element-131" />
          <picture data-id="element-132">
            <source srcSet="https://cdn.magicpatterns.com/uploads/eZounNzacuoaNCeuqDgEtL/mocap_sin_fondo_mi_espacio_interior.png" type="image/png" data-id="element-133" />
            <img src="https://cdn.magicpatterns.com/uploads/eZounNzacuoaNCeuqDgEtL/mocap_sin_fondo_mi_espacio_interior.png" alt="Megapack Mi Espacio Interior — Colección Completa" className="relative z-10 w-full h-auto drop-shadow-2xl max-w-[1080px] mx-auto" width={1080} height={1080} loading="eager" decoding="async" fetchPriority="high" data-id="element-134" />
          </picture>
        </div>

        {/* Product Description */}
        <div className="hero-animate-3 max-w-3xl mx-auto mb-6 md:mb-10" data-id="element-135">
          <p className="text-sm md:text-lg text-slate-400 leading-relaxed" data-id="element-136">
            El sistema de 6 tomos + 6 bonos que le da a padres, docentes y
            terapeutas las herramientas exactas para acompañar a los
            adolescentes a gestionar sus emociones, tomar decisiones sanas y
            enfrentar el día a día con calma y claridad.
          </p>
        </div>

        {/* Trust Badges */}
        <div className="hero-animate-4 flex flex-wrap items-center justify-center gap-2 md:gap-3 mb-6 md:mb-10" data-id="element-137">
          {[{
          emoji: '📄',
          label: '100% PDF'
        }, {
          emoji: '⚡',
          label: 'Acceso inmediato'
        }, {
          emoji: '👨‍👩‍👧',
          label: 'Para Padres · Docentes · Terapeutas'
        }, {
          emoji: '📚',
          label: '6 Tomos + 6 Bonos'
        }].map((badge, i) => <span key={i} className="inline-flex items-center gap-1.5 md:gap-2 px-3 py-1.5 md:px-4 md:py-2 rounded-full bg-navy-700/60 border border-navy-600 text-xs md:text-sm font-medium text-slate-300" data-id="element-138">
              <span data-id="element-139">{badge.emoji}</span> {badge.label}
            </span>)}
        </div>

        {/* CTA Button */}
        <div className="hero-animate-5 flex flex-col items-center" data-id="element-140">
          <button onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-gradient-to-r from-blue-600 to-cosmic-600 hover:from-blue-500 hover:to-cosmic-500 text-white font-semibold text-sm md:text-lg py-3 px-6 md:py-3.5 md:px-10 rounded-full shadow-[0_0_30px_rgba(168,85,247,0.3)] transition-all transform hover:scale-[1.03] flex items-center justify-center gap-2" data-id="element-141">
            ✨ → QUIERO MI ESPACIO INTERIOR AHORA
          </button>

          {/* Payment Info */}
          <div className="flex flex-wrap items-center justify-center gap-2 md:gap-5 mt-4 md:mt-5 text-[10px] md:text-sm text-slate-500" data-id="element-142">
            <span data-id="element-143">🛡️ Garantía 7 días</span>
            <span className="text-slate-700" data-id="element-144">•</span>
            <span data-id="element-145">🔒 Pago seguro</span>
            <span className="text-slate-700" data-id="element-146">•</span>
            <span data-id="element-147">💳 Mercado Pago | Tarjeta</span>
            <span className="text-slate-700" data-id="element-148">•</span>
            <span data-id="element-149">🌎 Pagalo en tu moneda local</span>
          </div>
        </div>
      </div>
    </section>;
}